export default {

      'debounce-vtext': {
        inserted: function(el, binding, vnode) {
          let timer;
          let event = binding.arg || 'input';
          el.addEventListener(event, () => {
            if (timer) {
              clearTimeout(timer);
            }
            timer = setTimeout(() => {
              let value = vnode.componentInstance.$props.value;
              binding.value(value);
            }, 300);
          });
        }
      },
    
      'debounce-ntext': {
        inserted: function(el, binding) {
          let timer;
          el.addEventListener('input', () => {
            if (timer) {
              clearTimeout(timer);
            }
            timer = setTimeout(() => {
              binding.value(el.value);
            }, 1000);
          });
        }
      },
      
    'scroll-to': {
        inserted: function (el, binding) {
            el.addEventListener('click', function () {
            const targetElement = document.querySelector(binding.value);
            if (targetElement) {
                targetElement.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: "start",
                    inline: "start",
                }
                );
            }
            });
        }
    }
    
};